import { boot } from "quasar/wrappers";
import useHaiiExAuth, {
  UserInfoType,
} from "src/composables/server/useHaiiExAuth";
import cookie from "js-cookie";
import { sessionUser, useAuthStore } from "stores/useAuthStore";
import useFormeServer from "src/composables/server/useFormeServer";
import { useKidsStore } from "stores/useKidsStore";
import { useKidStore } from "stores/useKidStore";
import { LoginRoutesConst, LogoutRoutesConst } from "src/types/constType";
import { isString } from "src/types/typeGuard";
import useConst from "src/composables/useConst";

export default boot(async ({ router }) => {
  const exAuth = useHaiiExAuth();
  const isProduction = process.env.VUE_APP_ENV === "prod";
  const signInRedirectURI = window.location.origin;
  exAuth.init({ serviceName: "forme", isProduction, signInRedirectURI });

  const authStore = useAuthStore();
  const formeServer = useFormeServer();
  const kidsStore = useKidsStore();
  const kidStore = useKidStore();

  // 유저 정보 조회
  async function fetchUser() {
    try {
      await exAuth.manageToken(false);
      const data = await exAuth.getUserInfo(false);
      if (typeof data === "string") {
        return false;
      }

      authStore.setUser(data);
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  // 로그인 여부 체크
  async function isSignIn(): Promise<boolean> {
    if (process.env.VUE_APP_ENV === "local") {
      await exAuth.manageToken(false);
      authStore.setUser({
        uuid: "dd7ea841-a036-47ab-a8a7-2f6456e9beb8",
        email: "chan@haii.io",
      } as UserInfoType);
      return true;
    }

    const at = cookie.get("_at");
    if (!at) {
      return false;
    }

    const uuid = sessionUser.value.uuid;
    if (!uuid) {
      return await fetchUser();
    }
    return true;
  }

  const { model } = useConst();
  // 자녀 리스트 조회
  async function fetchKidList() {
    try {
      const data = await formeServer.v2ResourcesListUser(model);
      if (isString(data)) {
        console.error(data);
        return;
      }
      console.log("exAuth.ts", data);

      if (!data.users?.length) {
        return;
      }
      kidsStore.setKids(data.users);

      const kidUUID = kidStore.getKid.UUID;
      if (data.users?.find((user) => user.UUID === kidUUID)) {
        return;
      }

      kidStore.setKid(kidsStore.getKids[0]);
    } catch (e) {
      console.error("exAuth.ts | fetchKidList |", e + "");
    }
  }

  const signState = await isSignIn();

  // 로그인 되어 있을시 아이리스트 api 호출
  if (signState) {
    await fetchKidList();
  }

  router.beforeEach((to, from, next) => {
    if (
      !signState &&
      Object.keys(LoginRoutesConst).includes(to.name as string)
    ) {
      next({ name: LogoutRoutesConst.SignIn });
    }

    if (
      signState &&
      Object.keys(LogoutRoutesConst).includes(to.name as string)
    ) {
      next({ name: LoginRoutesConst.Dashboard });
    }

    next();
  });
});
